export function initUtils( ){
    Object.defineProperty(String.prototype, 'capitalizeFirstLetter', {
        value: function () {
            return this.charAt(0).toUpperCase() + this.slice(1);
        },
        writable: true, // so that one can overwrite it later
        configurable: true // so that it can be deleted later
    });
}
